import { useEffect, useState } from "react";
import { apiRequest } from "@/helper/api";
import {
  calculateValidUntil,
  toSelectedExaminationIds,
  type ExaminationWithInterval,
} from "@/components/tables/modal/validUntil";

export interface UseValidUntilAutoCalcOptions {
  enabled: boolean;
  open: boolean;
  getValues: (name: string) => any;
  setValue: (
    name: string,
    value: any,
    options?: { shouldDirty?: boolean; shouldValidate?: boolean }
  ) => void;
}

export const useValidUntilAutoCalc = ({
  enabled,
  open,
  getValues,
  setValue,
}: UseValidUntilAutoCalcOptions) => {
  const [examinations, setExaminations] = useState<ExaminationWithInterval[]>(
    []
  );

  useEffect(() => {
    if (!enabled || !open) return;
    apiRequest({ method: "get", entity: "examination", getAllPages: true })
      .then((res) => setExaminations(res.data.results))
      .catch(() => {
        // the callback version had no failHandler — keep failures silent
      });
  }, [enabled, open]);

  const recalculateValidUntil = (
    changedFieldName: string,
    changedValue: any
  ): string | null => {
    if (!enabled || changedFieldName === "valid_until") return null;

    const examSelection =
      changedFieldName === "examination_set"
        ? changedValue
        : getValues("examination_set");
    const executedOn =
      changedFieldName === "executed_on"
        ? changedValue
        : getValues("executed_on");
    if (!executedOn) return null;

    const validUntil = calculateValidUntil(
      examinations,
      toSelectedExaminationIds(examSelection),
      executedOn
    );
    if (validUntil) {
      setValue("valid_until", validUntil, {
        shouldDirty: true,
        shouldValidate: true,
      });
    }
    return validUntil;
  };

  return { recalculateValidUntil };
};
